import { Box, Stack } from "@mui/material";

import { MinRateCapacityReason } from "@/features/FormV2/Step1/TicketingSelectionV2Card/helpers/calculateMaximumPurchasableTicketsForRate";
import { useRateSoldOutReasonMessage } from "@/features/FormV2/Step1/TicketingSelectionV2Card/hooks/useRateSoldOutReasonMessage";
import { FormCounter } from "@/forms-design-system/FormCounter/FormCounter";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedItemCounterButtonsProps = {
  itemType: "ticket" | "item" | "membership";
  amount: number;
  minimumToBuy?: number;
  maximumToBuy: number;
  maximumReason: MinRateCapacityReason;
  onIncrementClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onDecrementClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const ThemedItemCounterButtons = ({
  itemType,
  amount,
  minimumToBuy,
  maximumToBuy,
  maximumReason,
  onIncrementClick,
  onDecrementClick,
}: ThemedItemCounterButtonsProps) => {
  const { t } = useTranslate();

  const maximumReachedTooltipMessage = useRateSoldOutReasonMessage({ itemType, maximumToBuy, maximumReason });

  return (
    <Stack direction="column" gap={{ xs: 1, md: 0.5 }} data-test="themed-item-counter-buttons">
      <Stack direction="row" alignItems="center" gap={1}>
        <FormCounter
          value={amount}
          maxValue={maximumToBuy}
          onIncrementClick={onIncrementClick}
          onDecrementClick={onDecrementClick}
          maximumReason={amount >= maximumToBuy ? maximumReachedTooltipMessage : undefined}
        />
      </Stack>
      {(minimumToBuy || 1) > 1 && (
        <Box data-test="themed-item-counter-buttons-minimum-required" textAlign={{ md: "center" }}>
          <FormTypography variant="caption" vibe="brand">
            {t("ticketing", "minimumRequired", { minimumToBuy })}
          </FormTypography>
        </Box>
      )}
    </Stack>
  );
};
